import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Save, Loader2 } from "lucide-react";
import { toast } from "sonner";

const ContactEditor = ({ content, onSave }) => {
  const [formData, setFormData] = useState({
    section_label: "",
    title: "",
    subtitle: "",
    phone: "",
    address: "",
    website: ""
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (content) {
      setFormData(content);
    }
  }, [content]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const success = await onSave(formData);
    setSaving(false);
    if (success) {
      toast.success("Contacto actualizado correctamente");
    } else {
      toast.error("Error al guardar los cambios");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="contact-editor"
    >
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Editar Contacto</h1>
          <p className="text-[#94a3b8]">Modifica la información de contacto</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="glass-card p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Textos de la Sección</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Etiqueta</label>
              <input type="text" name="section_label" value={formData.section_label} onChange={handleChange} className="contact-input w-full" />
            </div>
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Título</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} className="contact-input w-full" />
            </div>
          </div>
          <div className="mt-4">
            <label className="block text-[#94a3b8] text-sm mb-2">Subtítulo</label>
            <textarea name="subtitle" value={formData.subtitle} onChange={handleChange} rows={2} className="contact-input w-full resize-none" />
          </div>
        </div>

        <div className="glass-card p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Información de Contacto</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Teléfono</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="contact-input w-full" placeholder="718-916-1401" />
            </div>
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Website</label>
              <input type="text" name="website" value={formData.website} onChange={handleChange} className="contact-input w-full" placeholder="globalmetafora.com" />
            </div>
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Dirección</label>
              <input type="text" name="address" value={formData.address} onChange={handleChange} className="contact-input w-full" placeholder="820 E 168TH ST BRONX NY 10459" />
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button type="submit" disabled={saving} className="btn-primary flex items-center gap-2">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
            <span>{saving ? "Guardando..." : "Guardar Cambios"}</span>
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default ContactEditor;
